import { render, staticRenderFns } from "./ProductsWithoutPriceModal.vue?vue&type=template&id=f39c79ba&scoped=true"
import script from "./ProductsWithoutPriceModal.vue?vue&type=script&lang=js"
export * from "./ProductsWithoutPriceModal.vue?vue&type=script&lang=js"
import style0 from "./ProductsWithoutPriceModal.vue?vue&type=style&index=0&id=f39c79ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39c79ba",
  null
  
)

export default component.exports